import { useEffect, useState } from "react";

import { getLots } from "services/sosInventoryService/sosApi";
import { dateToSosISODateTime } from "services/utility/dates";

/**
 * @name    useItemLocationLots
 *
 * @summary returns an array of lots, optionally filtered by item, location,
 *          and bin
 *
 * @param   itemId (number)
 *          locationName (string) name property of a location reference
 *            object
 *          dateTime (date) date/time at which onhand quantities should be
 *            calculated
 *          lotTracking (boolean) is lot tracking enabled for this item?
 *          binId (number, optional)
 *
 * @returns array of lots; while waiting for API response, returns null
 */
export function useItemLocationLots(
  itemId,
  locationName,
  binId,
  date,
  lotTracking
) {
  const [lots, setLots] = useState(null);

  useEffect(() => {
    async function _getLots(itemId, locationName, binId, date) {
      const params = {
        itemId,
        binId,
        location: locationName,
        dt: dateToSosISODateTime(date),
      };
      const lots = await getLots(params);

      setLots(lots);
    }

    if (Boolean(itemId && locationName && date && lotTracking)) {
      setLots(null);
      _getLots(itemId, locationName, binId, date);
    } else {
      setLots([]);
    }
  }, [itemId, locationName, binId, date, lotTracking]);

  return lots;
}
